<template>
  <v-layout column align-center>
    <img class="image" src="/static/images/document/chat-icon.svg" alt="Comentários">
    <span class="grey--text text--lighten-1">Seja o primeiro a comentar!</span>
  </v-layout>
</template>

<script>
export default {
  name: 'EmptyDocumentDiscussion',
};
</script>



// WEBPACK FOOTER //
// src/components/document/show/EmptyDocumentDiscussion.vue